import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { AGE_OPTIONS } from '../../data/quizOptions';
import { useCopy } from '../../contexts/LanguageContext';
import type { StepProps } from '../../types/quiz';
export function StepAge({
  profile,
  update,
  onNext
}: StepProps) {
  const copy = useCopy();
  return <div className="flex flex-1 flex-col" data-id="element-101" data-mp="mwsyu8pvfsat">
      <Headline data-id="element-102" data-mp="mvzypqlf411n">{copy.steps.age.headline(profile.child_name)}</Headline>
      <Subtext data-id="element-103" data-mp="rub8y2fmkdke">{copy.steps.age.subtext}</Subtext>

      <div className="mt-7 grid grid-cols-4 gap-3" data-id="element-104" data-mp="rx78fv74faay">
        {AGE_OPTIONS.map(age => {
        const selected = profile.child_age === age;
        return <button key={age} type="button" aria-pressed={selected} onClick={() => update({
          child_age: age
        })} className={`rounded-2xl border py-4 text-base font-semibold transition-all duration-200 active:scale-95 ${selected ? 'border-violet-500 bg-violet-500/10 text-violet-700 shadow-soft' : 'border-lavender-200 bg-white/90 text-ink shadow-soft'}`} data-id="element-105" data-mp="10vitzit4rhwj">
              {age}
            </button>;
      })}
      </div>

      <div className="mt-auto pt-10" data-id="element-106" data-mp="xc4fr9hr9b3s">
        <PrimaryButton onClick={onNext} disabled={!profile.child_age} data-id="element-107" data-mp="xd5xtxx6uxv0">
          {copy.quiz.continue}
        </PrimaryButton>
      </div>
    </div>;
}